// bao migrate skip
import * as ko from "knockout";
import AppTabController from "./../services/app-tab-controller";
import BaoMenu from "./../services/bao-menu";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./bao-dialog";
import QrDialog from "./qr-dialog";
import TabPage from "./tab-page";

class BaseViewModel {

	public SettingsUrl: KnockoutObservable<string> = ko.observable(null);
	public SettingsKeyPermission: KnockoutObservable<string> = ko.observable(null);
	public SettingsKeyPermissionApplicationId: KnockoutObservable<string> = ko.observable(null);
	public PermissionRefresh: string;
	public PermissionSave: string;
	public PermissionDelete: string;
	public PermissionQRCode: string;
	public RefreshUrl: string;
	public SaveUrl: string;
	public DeleteUrl: string;
	public IsInUseUrl: string;
	public DeleteMessageKey: string;
	public IsInUseMessageKey: string;
	public SaveCheckMessageKey: string;
	public PrimaryKey: any;
	public TabPage: TabPage;
	constructor(tabPage: TabPage) {
		const self: any = this;
		self.TabPage = tabPage;
		self.BaoMenu = BaoMenu;
		self.TabName = ko.observable();
		self.SaveAllowed = ko.observable();
		self.SaveTime = ko.observable();
		self.Initialized = ko.observable(false);
		self.IsReadonly = ko.observable(false);
		self.ShowStatusDialog = ko.observable(false);
		self.QrLabel = ko.observable("");
		self.IsNew = ko.observable(false);
		self.Destroy = [];
		self.subscriptions = [];
		self.TabName.subscribe((value) => {
			tabPage.Title(value);
		});
		self.Focus = function () { };
		self.DeferredCompleteCheck = () => {
			const def = $.Deferred();
			const resultComplete = self.CompleteCheck();
			if (resultComplete != null && resultComplete.then != null && typeof resultComplete.then === "function") {
				resultComplete.then((result) => {
					def.resolve(result);
				});
			} else {
				def.resolve(resultComplete);
			}
			return def.promise();
		};
		tabPage.MenuEvents.push(BaoMenu.registerEvent((value) => {
			if (tabPage.IsActiveTab() === true) {
				switch (value.ActionKey()) {
					case self.PermissionSave:
						self.DeferredCompleteCheck().then((result) => {
							if (result == true) {
								self.Save();
							}
						});
						break;
					case self.PermissionRefresh:
						self.BeforeRefresh();
						break;
					case self.PermissionDelete:
						self.BeforeDelete();
						break;
					case self.PermissionQRCode:
						self.GenerateQRCode();
						break;
				}
			}
		}));
		self.subscribe(self.IsNew, (value) => {
			self.BaoMenu.permissionEnable({ ActionKey: ko.unwrap(self.PermissionRefresh), Enabled: !value, Context: self.TabPage.Context() });
		});
	}
	public Focus() { }
	public CompleteCheck() {
		return true;
	}
	public DestroyObject = () => {
		const self: any = this;
		for (let i = 0; i < self.Destroy.length; i++) {
			if (typeof self.Destroy[i] === "function") {
				self.Destroy[i]();
			}
		}
		for (let y = 0; y < self.subscriptions.length; y++) {
			self.subscriptions[y].dispose();
		}
		self.Destroy = null;
		self.subscriptions = null;
	}
	public BeforeClose = (fn) => {
		const self: any = this;
		if (self.TabPage.DirtyFlag() == true && self.SaveAllowed() === true) {
			const questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(self.SaveCheckMessageKey), "question");
			questionDialog.DialogResult.subscribe((result) => {
				if (result === true) {
					self.DeferredCompleteCheck().then((result) => {
						if (result == true) {
							self.TabPage.IsLoading(true);
							self.Save().done((data) => {
								self.TabPage.IsLoading(false);
								self.DestroyObject();
								fn();
							});
						}
					});
				} else if (result === false) {
					self.DestroyObject();
					fn();
				}
			});
		} else {
			self.DestroyObject();
			fn();
		}
	}
	public BeforeRefresh() {
		const self: any = this;
		if (self.TabPage.DirtyFlag() == true && (self.SaveAllowed == null || self.SaveAllowed())) {
			const questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(self.SaveCheckMessageKey), "question");
			questionDialog.DialogResult.subscribe((result) => {
				if (result == true) {
					self.DeferredCompleteCheck().then((result) => {
						if (result == true) {
							self.Save();
						}
					});
				} else if (result === false) {
					self.PerformRefresh();
				}
			});
		} else {
			self.PerformRefresh();
		}
	}
	public BeforeDelete() {
		const self: any = this;
		if (self.IsInUseUrl == "") {
			self.BeforeDeleteQuestion();
		} else {
			Bao.post(self.IsInUseUrl, JSON.stringify({
				id: self.OpenData()
			}), (value) => {
				if (value != "true") {
					self.BeforeDeleteQuestion();
				} else {
					new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(self.IsInUseMessageKey), "info");
				}
			});
		}
	}
	public BeforeDeleteQuestion() {
		const self: any = this;
		const yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(self.DeleteMessageKey), "yesno");
		yesNoDialog.DialogResult.subscribe((result) => {
			if (result === true) {
				self.Delete();
			}
		});
	}
	public PerformRefresh() {
		const self: any = this;
		self.TabPage.IsLoading(true);
		return Bao.post(self.RefreshUrl, JSON.stringify({
			id: self.OpenData()
		}), (value) => {
			self.TabPage.DirtyFlag.pause();
			ko.map.fromJS(value, self, self.TabPage.DirtyFlag);
			self.TabPage.ObjectId(self.OpenData());
			self.TabPage.DirtyFlag.reset();
			self.TabPage.IsLoading(false);
		});
	}
	public GenerateQRCode() {
		const self: any = this;
		const qrDialog = new QrDialog(window.location.href, self.QrLabel());
		qrDialog.Open();
	}
	public MinimizeEntity() {
		const self: any = this;
		const model = ko.map.toJS(self, true);
		for (const o in model) {
			if (typeof model[o] === "object" || typeof model[o] === "function") {
				delete model[o];
			}
		}
		return model;
	}
	public Save() {
		const self: any = this;
		self.TabPage.IsLoading(true);
		return Bao.post(self.SaveUrl, JSON.stringify({
			model: self.MinimizeEntity()
		}), (value) => {
			self.SaveTime(value.Result);
			self.PerformRefresh();
		});
	}
	public Delete() {
		const self: any = this;
		self.TabPage.IsLoading(true);
		return Bao.post(self.DeleteUrl, JSON.stringify({
			id: self.OpenData()
		}), () => {
			self.TabPage.IsLoading(false);
			self.TabPage.DirtyFlag(false);
			AppTabController.RemoveTab(self.TabPage);
		});
	}
	public init() {
		const self: any = this;
		const def = $.Deferred();
		self.TabPage.IsLoading(true);
		if (self.RefreshUrl != "") {
			Bao.post(self.RefreshUrl, JSON.stringify({
				id: self.TabPage.UrlData().id
			}), (model) => {
				ko.map.fromJS(model, self, self.TabPage.DirtyFlag);
				self.TabPage.SessionTabId = self.SessionTabId();
				if (self.IsNew() || self.TabPage.ObjectId() != self[self.PrimaryKey]()) {
					self.TabPage.ObjectId(self[self.PrimaryKey]());
				} else {
					self.TabPage.ObjectId.valueHasMutated();
				}
				def.resolve();
			});
		} else {
			def.resolve();
		}
		return def.promise();
	}
	public subscribe(obs, fn) {
		const self: any = this;
		self.subscriptions.push(obs.subscribe(fn));
	}
	public loaded() {
		const self: any = this;
		self.TabPage.DirtyFlag.reset();
		self.TabPage.IsLoading(false);
		self.Focus();
		self.QrLabel(self.TabPage.Title());
	}
}

BaseViewModel.prototype.PermissionRefresh = "";
BaseViewModel.prototype.PermissionSave = "";
BaseViewModel.prototype.PermissionDelete = "";
BaseViewModel.prototype.PermissionQRCode = "";
BaseViewModel.prototype.RefreshUrl = "";
BaseViewModel.prototype.SaveUrl = "";
BaseViewModel.prototype.DeleteUrl = "";
BaseViewModel.prototype.IsInUseUrl = "";
BaseViewModel.prototype.DeleteMessageKey = "msgDelete";
BaseViewModel.prototype.IsInUseMessageKey = "msgIsInUse";
BaseViewModel.prototype.SaveCheckMessageKey = "msgSaveCheck";
BaseViewModel.prototype.PrimaryKey = null;

export default BaseViewModel;
